export const EDITOR_EVENT_CHANNEL = 'editor';
export const TEMPLATE_CHANGE_EVENT = `${EDITOR_EVENT_CHANNEL}:template:change`;
